'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { connect, useSelector } from 'react-redux';
import { getAdAccounts, getAdAccountLimit } from 'AdsUI/selectors/AccountsSelectors';
import { hasUsersAndTeams } from 'AdsUI/selectors/AuthSelectors';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILock from 'ui-addon-upgrades/icons/UILock';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';

const ConnectFooterWithPql = () => {
  const {
    openUpgradeModal
  } = useUpgradeModal('ads-account-select');
  return /*#__PURE__*/_jsxs(UIButton, {
    use: "link",
    "data-test-id": "connect-account-button",
    onClick: openUpgradeModal,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "adAccountFilter.connect"
    }), /*#__PURE__*/_jsx(UILock, {
      className: "m-left-1"
    })]
  });
};

const ConnectFooterWithLink = ({
  footerNote,
  hasAccessToUsersAndTeams
}) => /*#__PURE__*/_jsxs(_Fragment, {
  children: [footerNote ? /*#__PURE__*/_jsxs(Small, {
    use: "help",
    children: [footerNote, /*#__PURE__*/_jsx("br", {})]
  }) : hasAccessToUsersAndTeams && /*#__PURE__*/_jsxs(Small, {
    use: "help",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "adAccountFilter.footerNote"
    }), /*#__PURE__*/_jsx("br", {})]
  }), /*#__PURE__*/_jsx(UIButton, {
    external: true,
    use: "link",
    href: `/settings/${PortalIdParser.get()}/marketing/ads/adAccounts`,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "adAccountFilter.connect"
    })
  })]
});

const ConnectAccountsFooter = ({
  adAccounts,
  adAccountLimit,
  hasAccessToUsersAndTeams,
  footerNote
}) => {
  const adOverviewAccountRequestStatus = useSelector(state => state.requestStatus.adAccountsOverview);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [adOverviewAccountRequestStatus.fetching && /*#__PURE__*/_jsx(UILoadingSpinner, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "adAccountFilter.loadingAllAccounts"
      }),
      showLabel: true
    }), adAccounts.size >= adAccountLimit && /*#__PURE__*/_jsx(ConnectFooterWithPql, {}), adAccounts.size < adAccountLimit && /*#__PURE__*/_jsx(ConnectFooterWithLink, {
      footerNote: footerNote,
      hasAccessToUsersAndTeams: hasAccessToUsersAndTeams
    })]
  });
};

export default connect(state => ({
  adAccounts: getAdAccounts(state),
  adAccountLimit: getAdAccountLimit(state),
  hasAccessToUsersAndTeams: hasUsersAndTeams(state)
}))(ConnectAccountsFooter);